<template>
  <section id="hero" class="bg-white">
    <div class="relative isolate pt-14">
      <div
        class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
        aria-hidden="true"
      >
        <div
          class="relative left-[calc(50%-11rem)] aspect-1155/678 w-144.5 -translate-x-1/2 rotate-30 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-288.75"
          style="
            clip-path: polygon(
              74.1% 44.1%,
              100% 61.6%,
              97.5% 26.9%,
              85.5% 0.1%,
              80.7% 2%,
              72.5% 32.5%,
              60.2% 62.4%,
              52.4% 68.1%,
              47.5% 58.3%,
              45.2% 34.5%,
              27.5% 76.7%,
              0.1% 64.9%,
              17.9% 100%,
              27.6% 76.8%,
              76.1% 97.7%,
              74.1% 44.1%
            );
          "
        ></div>
      </div>
      <div class="py-24 sm:py-32 lg:pb-40">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto max-w-2xl text-center">
            <h1
              class="text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl"
            >
              Welcome to the Juniper Education
              <TextUnderline>Mobile App</TextUnderline>
            </h1>
            <p
              class="mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8"
            >
              Accept your invite as a teacher or parent and download our mobile
              app. Find out everything it offers below:
            </p>
          </div>
          <div
            class="mt-16 grid gap-4 sm:mt-24 md:grid-cols-2 sm:gap-8 md:gap-16"
          >
            <div
              data-aos="fade-right"
              @click="goTo('teacher')"
              @keydown.enter="goTo('teacher')"
              tabindex="0"
              class="rounded-xl bg-gray-900/5 p-2 ring-1 ring-gray-900/10 ring-inset group transition-all cursor-pointer hover:scale-105 hover:ring-purple-600 hover:bg-purple-600/20 focus:scale-105 focus:ring-purple-600 focus:bg-purple-600/20 lg:-m-4 lg:rounded-2xl lg:p-4"
            >
              <div
                class="overflow-hidden rounded-lg bg-white relative group-hover:bg-purple-900"
              >
                <div class="flex flex-col justify-between gap-4">
                  <div class="p-2 rounded-xl m-4">
                    <span
                      class="text-base/7 font-semibold text-purple-600 relative group-hover:text-purple-400"
                      >App highlights for</span
                    >
                    <p
                      class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 group-hover:text-white sm:text-5xl"
                    >
                      Teachers
                    </p>
                  </div>
                  <img
                    src="/mockups/3.webp"
                    alt="Mockup mobile"
                    class="max-h-[200px] ms-auto grayscale-100 transition-transform group-hover:grayscale-0 group-hover:scale-120"
                    height="200"
                    width="100"
                  />
                </div>
                <img
                  src="/graphics/green/arrow-1.svg"
                  alt="arrow graphic"
                  class="absolute bottom-0 w-48 opacity-0 transition-opacity group-hover:opacity-100"
                  height="110"
                  width="190"
                />
              </div>
            </div>
            <div
              data-aos="fade-left"
              @click="goTo('parent')"
              @keydown.enter="goTo('teacher')"
              tabindex="0"
              class="rounded-xl bg-gray-900/5 p-2 ring-1 ring-gray-900/10 ring-inset group transition-all cursor-pointer hover:scale-105 hover:ring-gray-600 hover:bg-purple-600/20 focus:scale-105 focus:ring-purple-600 focus:bg-purple-600/20 lg:-m-4 lg:rounded-2xl lg:p-4"
            >
              <div
                class="overflow-hidden rounded-lg bg-white relative group-hover:bg-purple-900"
              >
                <div class="flex flex-col-reverse justify-between gap-4">
                  <div class="p-2 rounded-xl m-4">
                    <span
                      class="text-base/7 font-semibold text-purple-600 relative group-hover:text-purple-400"
                      >App highlights for</span
                    >
                    <p
                      class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 group-hover:text-white sm:text-5xl"
                    >
                      Parents
                    </p>
                  </div>
                  <img
                    src="/mockups/4.webp"
                    alt="Mockup mobile"
                    class="max-h-[200px] ms-auto grayscale-100 transition-transform group-hover:grayscale-0 group-hover:scale-120"
                    height="200"
                    width="100"
                  />
                </div>
                <img
                  src="/graphics/green/arrow-2.svg"
                  alt="arrow graphic"
                  class="absolute top-0 w-48 opacity-0 transition-opacity group-hover:opacity-100"
                  height="160"
                  width="190"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
        aria-hidden="true"
      >
        <div
          class="relative left-[calc(50%+3rem)] aspect-1155/678 w-144.5 -translate-x-1/2 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-288.75"
          style="
            clip-path: polygon(
              74.1% 44.1%,
              100% 61.6%,
              97.5% 26.9%,
              85.5% 0.1%,
              80.7% 2%,
              72.5% 32.5%,
              60.2% 62.4%,
              52.4% 68.1%,
              47.5% 58.3%,
              45.2% 34.5%,
              27.5% 76.7%,
              0.1% 64.9%,
              17.9% 100%,
              27.6% 76.8%,
              76.1% 97.7%,
              74.1% 44.1%
            );
          "
        ></div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
import TextUnderline from "../TextUnderline.vue";

const router = useRouter();

const goTo = (link: string) => {
  router.push(`/${link}`);
};
</script>
